import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Unauthorized.css";

const Unauthorized = () => {
    const navigate = useNavigate();
    const role = localStorage.getItem('role') || '';

    useEffect(() => {
        if (localStorage.getItem('is_authenticated') === 'false') {
            navigate('/login');
        }
    }, [])

    const handleGoBack = () => {
        if (role === '') {
            navigate('/login');
        } else {
            navigate(`/${role}/dashboard`);
        }
    };

    return (
        <div className="container">
            <div className="not-found-container">
                <h1 className="not-found-title">403</h1>
                <p className="not-found-message">شما به این صفحه دسترسی ندارید</p>
                <button className="not-found-link btn medium-text" onClick={handleGoBack}>
                    بازگشت
                </button>
            </div>
        </div>
    );
};

export default Unauthorized;
